// extracted by mini-css-extract-plugin
export default {"wrapper":"AppearanceTabSettingsContainer_wrapper__+BTV-","title":"AppearanceTabSettingsContainer_title__AqbE2","fieldsWrapper":"AppearanceTabSettingsContainer_fieldsWrapper__-BAIe"};